const ChatType = {
  property: "property",
  reply: "propertyRequestReply",
  company: "propertyCompany",
};

export default ChatType;
